import { defineLocale } from "../../registry";

const errors = defineLocale({
  ru: {
    "errors.forbidden": "Ваши права изменились, обновите страницу",
    "errors.blocked": "Сохранение заблокировано до обновления страницы",
    "errors.validation":
      "Сервер отклонил часть значений. Введённые данные сохранены в форме",
    "errors.snapshotUnavailable":
      "Ничего не отправлено: карточка не содержит названий опций, а сервер принимает контент только целиком. Откройте вкладку «Опции», заново введите названия и сохраните",
    "errors.optionInUse":
      "Опция не удалена: по ней уже есть клики, и сервер хранит их вместе с опцией. Верните опцию в список и сохраните снова; убрать её из выдачи без удаления в консоли пока нельзя",
    "errors.geoTooLarge":
      "Геометрия слишком большая (максимум {max} КиБ). Упростите линию или уберите лишние точки",
    "errors.offline.hint": "Подключитесь к сети, чтобы повторить",
    "errors.rateLimited.retryIn": "Повторить через {seconds} с",
    "errors.session.refreshing": "Обновляем сессию…",
    "errors.session.refreshed":
      "Сессия обновлена. Нажмите «Сохранить», чтобы повторить попытку",
    "errors.session.expired": "Сессия истекла. Войдите снова",
    "errors.session.redirecting": "Переходим ко входу…",
    "errors.session.warning":
      "Несохранённые изменения этой формы могут быть потеряны при переходе ко входу",
    "errors.session.signIn": "Войти",
  },
  en: {
    "errors.forbidden": "Your permissions have changed, please refresh the page",
    "errors.blocked": "Saving is blocked until the page is refreshed",
    "errors.validation":
      "The server rejected some values. Your input is kept in the form",
    "errors.snapshotUnavailable":
      "Nothing was sent: the card does not carry the option titles, and the server accepts content only as a whole. Open the Options tab, enter the titles again and save",
    "errors.optionInUse":
      "The option was not deleted: it already has clicks, and the server keeps them together with the option. Put the option back and save again; there is no way yet to hide it from the feed without deleting it",
    "errors.geoTooLarge":
      "The geometry is too large (maximum {max} KiB). Simplify the line or remove extra points",
    "errors.offline.hint": "Reconnect to retry",
    "errors.rateLimited.retryIn": "Retry in {seconds} s",
    "errors.session.refreshing": "Refreshing your session…",
    "errors.session.refreshed":
      "Your session was refreshed. Press Save to try again",
    "errors.session.expired": "Your session has expired. Please sign in again",
    "errors.session.redirecting": "Taking you to sign-in…",
    "errors.session.warning":
      "Unsaved changes in this form may be lost when you go to sign-in",
    "errors.session.signIn": "Sign in",
  },
});

export default errors;
